import { render, staticRenderFns } from "./UploadRequestedDocument.vue?vue&type=template&id=37363291&scoped=true"
import script from "./UploadRequestedDocument.vue?vue&type=script&lang=js"
export * from "./UploadRequestedDocument.vue?vue&type=script&lang=js"
import style0 from "./UploadRequestedDocument.vue?vue&type=style&index=0&id=37363291&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37363291",
  null
  
)

export default component.exports